import { render, staticRenderFns } from "./SummaryPurchase.vue?vue&type=template&id=86b09c0a"
import script from "./SummaryPurchase.vue?vue&type=script&lang=js"
export * from "./SummaryPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports